/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { EditImageSelector } from "../../../challenges/challenge-upsert/image-modal/EditImageSelector";
import { ChallengeImageWrapper } from "../../../challenges/challenge-upsert/ChallengeImageWrapper";
import { ImagePreview } from "../../../challenges/challenge-upsert/ImagePreview";
import { useFormContext } from "react-hook-form";
import { useUploadHomepageImage } from "../../../../service/api";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../../../style-util";

type Props = {
  isEdit: boolean;
};

export const AppHomepageImageSection = ({ isEdit }: Props) => {
  const { setValue, watch } = useFormContext();
  const { mutateAsync: uploadImage, isLoading } = useUploadHomepageImage();
  const files = watch("files");
  const fileOnChange = async (acceptedFiles: File[]) => {
    setValue("files", acceptedFiles);
  };
  return (
    <CardContainer>
      <PageHeader
        title="Homepage image"
        subtitle="Upload image for your homepage. We recommend 1184px X 1184px."
      >
        {isEdit && (
          <EditImageSelector
            imageUploadIsLoading={isLoading}
            uploadImage={uploadImage}
            modalHeader="Edit image for this homepage"
          />
        )}
      </PageHeader>
      <CardBody css={cardBottomPadding}>
        {!isEdit && (
          <ChallengeImageWrapper
            file={files && files[0]}
            onDrop={fileOnChange}
          />
        )}
        {isEdit && <ImagePreview />}
      </CardBody>
    </CardContainer>
  );
};
